import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { CreateRuleDTO, RequestRuleResponse } from "@/types";

async function createRule(
  request: CreateRuleDTO
): Promise<RequestRuleResponse> {
  const response = await httpRequest.post<RequestRuleResponse>(
    "/roles",
    request
  );
  return response.data;
}

export function useCreateRuleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createRule,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: ["roles"] });
    },
  });
}
